// src/utils/adminLandingsApi.js
//
// Visits, demo requests and signups per landing page (?page=) and per
// Google Ads keyword (backend routes/adminLandings.ts, admins only).
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export async function landingStats(days, token) {
  const r = await fetch(`${API_BASE_URL}/admin/landings/stats?days=${days}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP_${r.status}`);
  return data;
}
